// extracted by mini-css-extract-plugin
export default {"container":"zN-z","dimension":"AN-z","dimensionLabels":"BN-z"};